import { useEffect } from 'react';
import { NEXT_PUBLIC_GA_MEASUREMENT_ID } from '@/lib/env';

/**
 * Google Analytics component for Vite build
 * Uses direct gtag implementation instead of @next/third-parties
 */
export function GoogleAnalytics() {
  useEffect(() => {
    if (!NEXT_PUBLIC_GA_MEASUREMENT_ID) return;

    // Load gtag script
    const script1 = document.createElement('script');
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${NEXT_PUBLIC_GA_MEASUREMENT_ID}`;
    document.head.appendChild(script1);

    // Initialize gtag
    const script2 = document.createElement('script');
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${NEXT_PUBLIC_GA_MEASUREMENT_ID}');
    `;
    document.head.appendChild(script2);

    return () => {
      // Cleanup on unmount
      document.head.removeChild(script1);
      document.head.removeChild(script2);
    };
  }, []);

  return null;
}
